if (typeof LevoCarrouselRecipes !== 'function') {
  class LevoCarrouselRecipes extends HTMLElement {
    constructor() {
      super();

      this.carrouselContent = this.querySelector('[data-carrousel-content]');
      this.carrouselHolder = this.querySelector('[data-carrousel-holder]');
      this.childsLength = this.carrouselContent.childElementCount;
      this.carrouselWidth = this.carrouselContent.offsetWidth;
      this.carrouselHeight = this.carrouselContent.offsetHeight;
      this.scrollLength = this.carrouselContent.firstElementChild.offsetWidth;
      this.currentPosition = 0;

      this.carrouselHolder.style.height = `${this.carrouselHeight}px`;

      this.prevButton = this.querySelector('[data-prev-button]');
      this.nextButton = this.querySelector('[data-next-button]');

      this.prevButton.addEventListener('click', () => this.scroll('prev'));
      this.nextButton.addEventListener('click', () => this.scroll('next'));

      this.startX = 0;
      this.currentX = 0;
      this.touching = false;

      this.carrouselContent.addEventListener('touchstart', this.onTouchStart.bind(this));
      this.carrouselContent.addEventListener('touchmove', this.onTouchMove.bind(this));
      this.carrouselContent.addEventListener('touchend', this.onTouchEnd.bind(this));

      this.cloneItems();
    }

    cloneItems() {
      const firstClone = document.createElement('div');
      const lastClone = document.createElement('div');

      firstClone.classList.add('clone');
      lastClone.classList.add('clone');

      Array.from(this.carrouselContent.children).forEach(child => {
        firstClone.appendChild(child.cloneNode(true));
        lastClone.appendChild(child.cloneNode(true));
      });

      this.carrouselContent.appendChild(firstClone);
      this.carrouselContent.insertBefore(lastClone, this.carrouselContent.firstChild);
    }

    updatePosition() {
      this.carrouselContent.style.transition = 'transform 0.5s ease';
      this.carrouselContent.style.transform = `translateX(-${this.currentPosition}px)`;
    }

    scroll(direction) {
      if (direction === 'next') {
        this.currentPosition += this.scrollLength;
        if (this.currentPosition >= this.carrouselWidth) {
          this.currentPosition = 0;
          this.carrouselContent.style.transition = 'none';
          this.carrouselContent.style.transform = `translateX(-${this.currentPosition}px)`;
          setTimeout(() => this.updatePosition(), 50);
          return;
        }
      } else if (direction === 'prev') {
        this.currentPosition -= this.scrollLength;
        if (this.currentPosition < 0) {
          this.currentPosition = this.carrouselWidth - this.scrollLength;
          this.carrouselContent.style.transition = 'none';
          this.carrouselContent.style.transform = `translateX(-${this.currentPosition}px)`;
          setTimeout(() => this.updatePosition(), 50);
          return;
        }
      }

      this.updatePosition();
    }

    onTouchStart(event) {
      this.touching = true;
      this.startX = event.touches[0].pageX;
      this.currentX = this.startX;
    }

    onTouchMove(event) {
      if (!this.touching) return;

      this.currentX = event.touches[0].pageX;
      const deltaX = this.currentX - this.startX;

      this.carrouselContent.style.transition = 'none';
      this.carrouselContent.style.transform = `translateX(-${this.currentPosition - deltaX}px)`;
    }

    onTouchEnd(event) {
      if (!this.touching) return;

      this.touching = false;
      const deltaX = this.currentX - this.startX;

      if (Math.abs(deltaX) > this.scrollLength / 2) {
        if (deltaX > 0) {
          this.scroll('prev');
        } else {
          this.scroll('next');
        }
      } else {
        this.updatePosition();
      }
    }
  }

  if (typeof customElements.get('levo-carrousel-recipes') == 'undefined') {
    customElements.define('levo-carrousel-recipes', LevoCarrouselRecipes);
  }
}